export const loadResultsWorkspace = null;
export const loadClientResultsCell = null;
